import React, { useState } from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./HotelAssistanceSection.scss";
// Import hotel images
import ahujaImg from "../../images/hotels/ahuja.webp";
import bloomImg from "../../images/hotels/bloom hotel.webp";
import emeraldImg from "../../images/hotels/emerald.webp";
import laSagritaImg from "../../images/hotels/la sagrita.webp";
import hansImg from "../../images/hotels/hans.webp";
import radissonImg from "../../images/hotels/raddison blu.webp";
import lalitImg from "../../images/hotels/lalit hotel.webp";
import parkImg from "../../images/hotels/The Park.webp";
import leMeridienImg from "../../images/hotels/le meridian.webp";

const HotelAssistanceSection = () => {
  const [activeTab, setActiveTab] = useState("threeStar");

  const hotels = {
    threeStar: [
      {
        name: "Ahuja Residency",
        location: "Sunder Nagar, New Delhi",
        address: "Sunder Nagar, New Delhi, Delhi 110003",
        link: "https://maps.app.goo.gl/423JkNiQJNdgGi26A",
        stars: 3,
        image: ahujaImg,
      },
      {
        name: "Bloom Boutique",
        location: "Connaught Place Area, New Delhi",
        address: "Connaught Place, New Delhi, Delhi",
        link: "https://maps.app.goo.gl/wbcya9N21YWwezsV8",
        stars: 3,
        image: bloomImg,
      },
      {
        name: "Emerald Hotels & Resorts",
        location: "Connaught Place Area, New Delhi",
        address: "Connaught Place, New Delhi, Delhi",
        link: "https://maps.app.goo.gl/CHgkAZM9AT1ynDwU6",
        stars: 3,
        image: emeraldImg,
      },
    ],
    fourStar: [
      {
        name: "La Sagrita",
        location: "Sunder Nagar, New Delhi",
        address: "Sunder Nagar, New Delhi, Delhi 110003",
        link: "https://maps.app.goo.gl/CErMfGbDUeYo6btb8",
        stars: 4,
        image: laSagritaImg,
      },
      {
        name: "The Hans",
        location: "New Delhi",
        address: "15 Barakhamba Road, New Delhi, Delhi 110001",
        link: "https://maps.app.goo.gl/JnDRCH5yzL29nMtDA",
        stars: 4,
        image: hansImg,
      },
      {
        name: "Radisson Blu Marina",
        location: "Connaught Place, New Delhi",
        address: "Connaught Place, New Delhi, Delhi",
        link: "https://maps.app.goo.gl/ersBKBHrCTeE1wpe9",
        stars: 4,
        image: radissonImg,
      },
    ],
    fiveStar: [
      {
        name: "The Lalit",
        location: "New Delhi",
        address: "Barakhamba Avenue, Connaught Place, New Delhi, Delhi 110001",
        link: "https://maps.app.goo.gl/yk31KHbvMaKsMC6MA",
        stars: 5,
        image: lalitImg,
      },
      {
        name: "The Park",
        location: "New Delhi",
        address: "15 Parliament Street, New Delhi, Delhi 110001",
        link: "https://maps.app.goo.gl/cL4WMJdJ9viDYSWx6",
        stars: 5,
        image: parkImg,
      },
      {
        name: "Le Méridien",
        location: "New Delhi",
        address: "Windsor Place, New Delhi, Delhi 110001",
        link: "https://maps.app.goo.gl/jg3QZ4R6bi4UDPFR6",
        stars: 5,
        image: leMeridienImg,
      },
    ],
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const currentHotels = hotels[activeTab];

  const renderStars = (count) => {
    return Array.from({ length: count }, (_, i) => (
      <i key={i} className="fa fa-star" style={{ color: "#F2BC00", fontSize: "14px" }}></i>
    ));
  };

  return (
    <section className="section-padding hotel-assistance-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionTitle
              title="Hotel Assistance"
              titleStyle={{ color: "#252686" }}
              paragarap="JSA helps you find trusted nearby hotels, but all payments are made directly to hotels by participants. JSA does not charge or handle any hotel payments."
              paragraphStyle={{ color: "#525252" }}
            />
          </div>
        </div>

        {/* Tabs */}
        <div className="row">
          <div className="col-12">
            <div className="hotel-tabs">
              <button
                className={`hotel-tab ${activeTab === "threeStar" ? "active" : ""}`}
                onClick={() => handleTabChange("threeStar")}
              >
                <span>3 Star Hotel</span>
              </button>
              <button
                className={`hotel-tab ${activeTab === "fourStar" ? "active" : ""}`}
                onClick={() => handleTabChange("fourStar")}
              >
                <span>4 Star Hotel</span>
              </button>
              <button
                className={`hotel-tab ${activeTab === "fiveStar" ? "active" : ""}`}
                onClick={() => handleTabChange("fiveStar")}
              >
                <span>5 Star Hotel</span>
              </button>
            </div>
          </div>
        </div>

        {/* Hotel Cards */}
        <div className="row">
          {currentHotels.map((hotel, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 col-12" style={{ marginBottom: "30px" }}>
              <div className="hotel-card">
                <div className="hotel-image">
                  <img
                    src={hotel.image}
                    alt={hotel.name}
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/400x250?text=Hotel+Image";
                    }}
                  />
                  <div className="hotel-stars">{renderStars(hotel.stars)}</div>
                </div>
                <div className="hotel-content">
                  <h3 className="hotel-name">{hotel.name}</h3>
                  <div className="hotel-location">
                    <i className="fa fa-map-marker"></i>
                    <span>{hotel.location}</span>
                  </div>
                  <div className="hotel-address">
                    <i className="fa fa-location-arrow"></i>
                    <span>{hotel.address}</span>
                  </div>
                  <a
                    href={hotel.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hotel-link-btn"
                  >
                    <i className="fa fa-map"></i>
                    <span>View on Google Maps</span>
                    <i className="fa fa-external-link"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HotelAssistanceSection;

